var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProvideData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_700_699)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_700_699",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 36,
    width: 78,
    height: 78
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125 36.1113H47.2222V113.889H125V36.1113Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_700_699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.0503 42.4637C80.0198 33.9939 92.2653 33.9939 97.2345 42.4637L97.415 42.7713C99.7078 46.6787 103.887 49.0917 108.417 49.1234L108.774 49.1259C118.594 49.1946 124.717 59.7994 119.866 68.338L119.69 68.6481C117.452 72.5873 117.452 77.4133 119.69 81.3523L119.866 81.6623C124.717 90.2011 118.594 100.806 108.774 100.875L108.417 100.877C103.887 100.909 99.7078 103.322 97.415 107.229L97.2345 107.537C92.2653 116.007 80.0198 116.007 75.0503 107.537L74.8698 107.229C72.5772 103.322 68.3979 100.909 63.8677 100.877L63.5111 100.875C53.6912 100.806 47.5686 90.2011 52.4189 81.6623L52.5951 81.3523C54.8327 77.4133 54.8327 72.5873 52.5951 68.6481L52.4189 68.338C47.5686 59.7994 53.6912 49.1946 63.5111 49.1259L63.8677 49.1234C68.3979 49.0917 72.5772 46.6787 74.8698 42.7713L75.0503 42.4637Z",
    fill: "#BEC294"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0501 44.6008C98.2035 44.1096 97.4975 43.4058 97.0096 42.5584C96.5332 41.7368 96.2634 40.786 96.2634 39.7691C96.2634 38.7521 96.5332 37.8013 97.0096 36.9797L67.3258 19.8271C66.8379 20.6775 66.129 21.3841 65.2824 21.8725C64.4645 22.3465 63.5145 22.6165 62.5014 22.6165C61.4883 22.6165 60.5355 22.3465 59.7147 21.8696C58.871 21.3784 58.1649 20.6746 57.6771 19.8271L27.9933 36.9797C28.4668 37.8013 28.7394 38.7521 28.7394 39.7691C28.7394 40.786 28.4668 41.7426 27.9875 42.5641C27.4996 43.4087 26.7965 44.1125 25.9527 44.6008C25.1319 45.0748 24.182 45.3477 23.166 45.3477V79.6816C24.1762 79.6816 25.1233 79.9516 25.9412 80.4227C26.785 80.9082 27.491 81.6091 27.9789 82.4508C28.4611 83.2695 28.7366 84.2261 28.7394 85.243V85.2603C28.7394 86.2657 28.4725 87.2108 28.0047 88.0266L57.6771 105.173C58.1649 104.329 58.871 103.622 59.7147 103.134C60.5355 102.657 61.4855 102.387 62.5014 102.387C63.5174 102.387 64.4673 102.657 65.2881 103.134C66.1319 103.622 66.8379 104.329 67.3258 105.173L96.9436 88.0582C96.5102 87.2654 96.2634 86.3519 96.2634 85.3838V85.3723C96.2663 84.3554 96.5389 83.4045 97.0153 82.5887C97.5032 81.7413 98.2092 81.0375 99.0559 80.5491C99.8738 80.0751 100.824 79.8051 101.837 79.8051V45.3477C100.821 45.3477 99.8709 45.0748 99.0501 44.6008ZM68.0749 62.5003C68.0749 63.5431 67.7879 64.5169 67.2914 65.3528C66.3184 66.9845 64.5362 68.079 62.5014 68.079C60.4666 68.079 58.6385 66.9558 57.6771 65.2896C57.2006 64.4681 56.928 63.5172 56.928 62.5003C56.928 61.4834 57.1892 60.5699 57.6484 59.7627C58.6012 58.0678 60.4178 56.9245 62.5014 56.9245C64.585 56.9245 66.3644 58.0448 67.3258 59.711C67.8022 60.5325 68.0749 61.4834 68.0749 62.5003Z",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7394 39.7681C28.7394 40.785 28.4668 41.7416 27.9875 42.5632C27.4996 43.4078 26.7965 44.1116 25.9527 44.5999C25.1319 45.0739 24.182 45.3468 23.166 45.3468C20.0894 45.3468 17.5926 42.8476 17.5926 39.7681C17.5926 36.6887 20.0894 34.1895 23.166 34.1895C25.2266 34.1895 27.029 35.3127 27.9933 36.9788C28.4668 37.8004 28.7394 38.7512 28.7394 39.7681Z",
    fill: "#D4D6B2",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0749 17.0377C68.0749 18.0546 67.8022 19.0054 67.3258 19.827C66.8379 20.6773 66.1291 21.384 65.2824 21.8723C64.4645 22.3463 63.5146 22.6163 62.5015 22.6163C61.4884 22.6163 60.5356 22.3463 59.7148 21.8695C58.871 21.3782 58.165 20.6744 57.6771 19.827C57.2007 19.0054 56.928 18.0546 56.928 17.0377C56.928 13.9582 59.4249 11.459 62.5015 11.459C65.578 11.459 68.0749 13.9582 68.0749 17.0377Z",
    fill: "#D4D6B2",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.407 39.7681C107.407 42.8476 104.913 45.3468 101.837 45.3468C100.821 45.3468 99.8709 45.0739 99.0501 44.5999C98.2035 44.1087 97.4975 43.4049 97.0096 42.5575C96.5332 41.7359 96.2634 40.785 96.2634 39.7681C96.2634 38.7512 96.5332 37.8004 97.0096 36.9788C97.971 35.3127 99.7734 34.1895 101.837 34.1895C104.913 34.1895 107.407 36.6887 107.407 39.7681Z",
    fill: "#D4D6B2",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.407 85.3834C107.407 88.4628 104.913 90.9592 101.837 90.9592C99.7275 90.9592 97.8907 89.7871 96.9436 88.0578C96.5102 87.2649 96.2634 86.3514 96.2634 85.3834V85.3719C96.2663 84.355 96.5389 83.4041 97.0154 82.5883C97.5032 81.7409 98.2093 81.0371 99.0559 80.5487C99.8738 80.0747 100.824 79.8047 101.837 79.8047C104.913 79.8047 107.407 82.301 107.407 85.3834Z",
    fill: "#D4D6B2",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0749 107.963C68.0749 111.045 65.578 113.541 62.5015 113.541C59.4249 113.541 56.928 111.045 56.928 107.963C56.928 106.946 57.2007 105.995 57.6771 105.173C58.165 104.329 58.871 103.622 59.7148 103.134C60.5356 102.657 61.4855 102.387 62.5015 102.387C63.5174 102.387 64.4674 102.657 65.2882 103.134C66.1319 103.622 66.8379 104.329 67.3258 105.173C67.8022 105.995 68.0749 106.946 68.0749 107.963Z",
    fill: "#D4D6B2",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7394 85.2431V85.2603C28.7394 86.2657 28.4725 87.2108 28.0047 88.0267C27.0462 89.7072 25.2381 90.839 23.166 90.839C20.0894 90.839 17.5926 88.3398 17.5926 85.2603C17.5926 82.1808 20.0894 79.6816 23.166 79.6816C24.1762 79.6816 25.1233 79.9517 25.9412 80.4228C26.785 80.9083 27.491 81.6092 27.9789 82.4509C28.4611 83.2696 28.7366 84.2262 28.7394 85.2431Z",
    fill: "#D4D6B2",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0096 42.5576L82.1376 51.1526L67.3258 59.7102",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6771 65.29L42.8337 73.8678L27.9789 82.4512",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0153 82.5884L82.1203 73.9504L67.2914 65.3525",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6484 59.763L42.8165 51.1623L27.9875 42.5645",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5014 102.387V85.3092V68.0791",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5014 56.9242V39.7688V22.6162",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7394 39.7686H49.3887H62.5014H75.5826H96.2634",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2634 85.3724L75.5539 85.3322L62.5014 85.3092L49.4202 85.2834L28.7394 85.2432",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2881 103.134L75.5539 85.3318L82.1203 73.9504L88.6954 62.5517L99.0501 44.6006",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7147 103.134L49.4203 85.283L42.8338 73.8671L36.2788 62.5L25.9528 44.6006",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0749 62.5006C68.0749 63.5434 67.7879 64.5172 67.2914 65.3531C66.3185 66.9848 64.5363 68.0793 62.5015 68.0793C60.4667 68.0793 58.6385 66.9561 57.6771 65.2899C57.2007 64.4684 56.928 63.5175 56.928 62.5006C56.928 61.4837 57.1892 60.5702 57.6484 59.763C58.6012 58.0681 60.4179 56.9248 62.5015 56.9248C64.585 56.9248 66.3644 58.0451 67.3258 59.7113C67.8022 60.5328 68.0749 61.4837 68.0749 62.5006Z",
    fill: "#D4D6B2",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2824 21.8721L75.5826 39.7687L82.1375 51.1529L88.6954 62.5516L99.0558 80.5487",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7148 21.8691L49.3887 39.7686L42.8165 51.1615L36.2788 62.4998L25.9413 80.4223",
    stroke: "#1A1A19",
    strokeWidth: 1.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_700_699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.7778,
    height: 77.7778,
    fill: "white",
    transform: "translate(47.2222 36.1113)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvideData);
export default __webpack_public_path__ + "static/media/provide-data.2cacc736e4eacc78692906f029c5c2f2.svg";
export { ForwardRef as ReactComponent };